import { IOS_APP_CHECKOUT_RETURN_PATH } from "@pax/api-contract/payments/v1alpha1";
import { buttonVariants, HapticSurface } from "@pax/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

const APP_LINK = `pax:/${IOS_APP_CHECKOUT_RETURN_PATH}`;

/**
 * Where Checkout opened from the iOS app returns. iOS normally opens the app before this page
 * loads; a browser that keeps the link, such as Chrome, lands here and hands over to the app.
 */
const AppReturnPage = () => {
  useEffect(() => {
    window.location.href = APP_LINK;
  }, []);

  return (
    <main className="mx-auto flex max-w-xl flex-col items-center px-6 py-20 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">Back to Pax</h1>
      <p className="mt-3 text-sm text-muted-foreground">
        Pax picks up your purchase as soon as it opens.
      </p>
      <a href={APP_LINK} className={buttonVariants({ className: "mt-6" })}>
        Open Pax
        <HapticSurface />
      </a>
    </main>
  );
};

export const Route = createFileRoute("/checkout/app-return")({
  head: () => ({ meta: [{ title: "Back to Pax · Pax.co" }] }),
  component: AppReturnPage,
});
